export default __webpack_public_path__ + "static/media/gallery.9b79d41d.jpg";